import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { WELLNESS_PACKAGES, waLink } from "@/data/site";

export default function WellnessPackages({ onBook }) {
  return (
    <section id="wellness" className="py-20 md:py-28 bg-slate-50/60" data-testid="wellness-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-turq-dark">Health Checkups</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-3 tracking-tight">Wellness Packages</h2>
          <p className="text-secondary mt-4">Complete analysis • Trusted results • Better health. Save 20% on all packages.</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {WELLNESS_PACKAGES.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.HeartPulse;
            return (
              <motion.div key={p.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className={`relative flex flex-col bg-white rounded-3xl border ${p.popular ? "border-turq shadow-[0_25px_60px_-20px_rgba(0,180,216,0.35)]" : "border-slate-100 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.06)]"} overflow-hidden`}
                data-testid={`wellness-card-${i}`}>
                {p.popular && <div className="absolute top-0 inset-x-0 bg-turq text-white text-[11px] font-bold uppercase tracking-wider text-center py-1.5">Most Popular</div>}
                <div className={`px-6 pt-${p.popular ? "10" : "7"} pb-5 ${p.popular ? "pt-10" : "pt-7"}`}>
                  <div className="flex items-center justify-between">
                    <div className="w-12 h-12 rounded-2xl bg-navy flex items-center justify-center text-turq-light"><Icon className="w-6 h-6" strokeWidth={1.6} /></div>
                    <span className="bg-emerald-100 text-emerald-700 text-xs font-bold px-3 py-1.5 rounded-full" data-testid={`wellness-save-${i}`}>SAVE 20%</span>
                  </div>
                  <h3 className="font-heading font-bold text-navy text-xl mt-4">{p.name}</h3>
                  <p className="text-xs uppercase tracking-wider text-turq-dark font-semibold">{p.tier}</p>
                  <div className="mt-4 flex items-end gap-2">
                    <span className="text-3xl font-bold text-navy font-heading">₹{p.price.toLocaleString("en-IN")}</span>
                    <span className="text-base text-muted line-through mb-1" data-testid={`wellness-original-${i}`}>₹{p.original.toLocaleString("en-IN")}</span>
                  </div>
                </div>
                <div className="border-t border-slate-100 px-6 py-5 flex-1">
                  <p className="text-xs font-semibold uppercase tracking-wider text-secondary mb-3">{p.tests.length} Tests Included</p>
                  <ul className="space-y-2">
                    {p.tests.map((t) => (
                      <li key={t} className="flex items-start gap-2 text-sm text-secondary">
                        <Check className="w-4 h-4 text-turq-dark mt-0.5 shrink-0" /> <span>{t}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="px-6 pb-6">
                  <button onClick={() => onBook(p.name)} className={`w-full rounded-full py-3.5 font-medium transition-all hover:-translate-y-0.5 ${p.popular ? "bg-turq hover:bg-turq-dark text-white shadow-[0_10px_30px_rgba(0,180,216,0.3)]" : "bg-navy hover:bg-navy-light text-white"}`} data-testid={`wellness-book-${i}`}>
                    Book This Package
                  </button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
